import PropTypes from 'prop-types';
import React from "react";

/*
import GatsbyLink from "gatsby-link";

export default class Link extends React.Component {
	static propTypes = {
		children: PropTypes.node,
		to: PropTypes.string.isRequired,
	}

	render() {
		const { children, to, ...otherProps } = this.props;

		const internal = /^\/(?!\/)/.test(to);

		const props = {
			...otherProps,
		};

		let Component = null;
		if (internal) {
			props.to = to;
			Component = GatsbyLink;
		} else {
			props.href = to;
			Component = "a";
		}

		return (
			<Component {...props}>
				{children}
			</Component>
		);
	}
}
*/


import GatsbyLink from "gatsby-link";

const Link = ({ children, to, ...other }) => {
  // Tailor the following test to your environment.
  // This example will assume that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is non-local.
  const internal = /^\/(?!\/)/.test(to);

  // Use gatsby-link for internal links, and <a> for others
  if (internal) {
    return <GatsbyLink to={to} {...other}>{children}</GatsbyLink>;
  }
  return <a href={to} {...other}>{children}</a>;
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link.jsx